<template>
  <div>
    <expense-details :expenseId="expenseId" />
    <vx-card id="loading-expense-card" class="vs-con-loading__container">
      <card-header
        :title="$t(cardTitle)"
        v-model="params.search"
        @search="search"
        @close="close"
      />

      <expense-table
        :data="items"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>

<script>
import ExpenseTable from '../tables/ExpenseTable.vue'
import ExpenseDetails from '../sidebards/ExpenseDetails.vue'
import dashboard from '@/http/requests/dashboard'
import CardHeader from '../components/CardHeader.vue'

export default {
  name: 'expense-card',
  components: {
    ExpenseTable,
    CardHeader,
    ExpenseDetails,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    title() {},
  },
  data() {
    return {
      cardTitle: 'expenses',
      cardId: 'loading-expense-card',
      items: [],
      expenseId: '',
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
        StatusId: ['6'],
        ClientName: 'KOLLMORGEN MOTION TECHNOLOGIES GROUP',
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.params.StatusId = this.data.StatusId
      this.params.ClientName = this.data.ClientName
      if (this.params.ClientName != null) {
        dashboard
          .ExpenseDataTable(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
              this.splitName()
            } else {
              this.items = [...this.items, ...response.data.result.data]
              this.splitName()
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      } else {
        dashboard
          .fullExpenseDataTable(this.params)
          .then((response) => {
            if (this.params.page === 1) {
              this.items = [...response.data.result.data]
              this.splitName()
            } else {
              this.items = [...this.items, ...response.data.result.data]
              this.splitName()
            }
            this.lastPage = response.data.result.last_page
            this.loading = false
          })
          .catch((response) => {
            this.showValidationErrors(response)
            this.loading = false
          })
      }
    },
    splitName() {
      try {
        for (let i = 0; i < this.items.length; i++) {
          let name = String (this.items[i].VendorName).trim()
          let divisor = name.length
          let partName1 = ''
          let partName2 = ''
          if (divisor > 40) {
            for (let j = 1; j < divisor; j++) {
              if (j < divisor / 2) partName1 += name[j]
              if (j > divisor / 2) partName2 += name[j]
            }
          } else {
            partName1 = name
          }
          let splitName = [partName1, partName2]
          this.items[i].VendorName = splitName
        }
      } catch (error) {
        console.error(error)
      }
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    close() {
      this.$emit('close')
    },
    showDetails(e) {
      this.expenseId = e
      this.$store.dispatch('toggleSidebar', 'sidebar-expense-details')
    },
  },
  mounted() {
    this.search()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    },
    data() {
      this.search()
    },
  },
}
</script>

